import styled from "@emotion/styled"
import {CardContainer} from "../ui/cardContainer"
import access from "../img/success.svg"
import {Main} from "../layout";

const TitleText = styled.p`
    font-size: 36px;
    margin: 0;
    color: #2f2410;
    text-align: center;
    font-family: "Lato", sans-serif;
    font-weight: bold;
`

const AccessImgContainer = styled.div`
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    img {
        width: 40%;
    }
`

const ContentContainer = styled.div`
    display: flex;
    padding: 160px 0 0;
    justify-content: center;
    flex-direction: column;
    align-content: center;
    gap: 50px;
`

export const Success = () => {
    return (<Main>
        <CardContainer>
            <ContentContainer>
                <TitleText>Ваша оплата прошла</TitleText>
                <AccessImgContainer>
                    <img src={access} alt="access"/>
                </AccessImgContainer>
            </ContentContainer>
        </CardContainer>
    </Main>)
}